import axios from "axios";
import { setSnackbar } from "../../../modules/snackbar/api/snackbar";
import { GET } from "../../genericAPI/api/actions";

export const GET_MESSAGE_SETTING_REQUEST =
  "SETTINGS/GET_MESSAGE_SETTING_REQUEST";
export const GET_MESSAGE_SETTING_RESPONSE =
  "SETTINGS/GET_MESSAGE_SETTING_RESPONSE";
export const GET_MESSAGE_SETTING_FAILURE =
  "SETTINGS/GET_MESSAGE_SETTING_FAILURE";

export const GET_SETTING_REQUEST = "SETTINGS/GET_SETTING_REQUEST";
export const GET_SETTING_RESPONSE = "SETTINGS/GET_SETTING_RESPONSE";
export const GET_SETTING_FAILURE = "SETTINGS/GET_SETTING_FAILURE";

export const GET_REPORTS_REQUEST = "SETTINGS/GET_REPORTS_REQUEST";
export const GET_REPORTS_RESPONSE = "SETTINGS/GET_REPORTS_RESPONSE";
export const GET_REPORTS_FAILURE = "SETTINGS/GET_REPORTS_FAILURE";

export const UPDATE_MESSAGE_SETTING_REQUEST =
  "SETTINGS/UPDATE_MESSAGE_SETTING_REQUEST";
export const UPDATE_MESSAGE_SETTING_RESPONSE =
  "SETTINGS/UPDATE_MESSAGE_SETTING_RESPONSE";
export const UPDATE_MESSAGE_SETTING_FAILURE =
  "SETTINGS/UPDATE_MESSAGE_SETTING_FAILURE";

export const UPDATE_SETTING_REQUEST = "SETTINGS/UPDATE_SETTING_REQUEST";
export const UPDATE_SETTING_RESPONSE = "SETTINGS/UPDATE_SETTING_RESPONSE";
export const UPDATE_SETTING_FAILURE = "SETTINGS/UPDATE_SETTING_FAILURE";

export const GET_ACTIVE_USERS_REQUEST = "SETTINGS/GET_ACTIVE_USERS_REQUEST";
export const GET_ACTIVE_USERS_RESPONSE = "SETTINGS/GET_ACTIVE_USERS_RESPONSE";
export const GET_ACTIVE_USERS_FAILURE = "SETTINGS/GET_ACTIVE_USERS_FAILURE";

export const UPDATE_ACTIVE_USERS_REQUEST =
  "SETTINGS/UPDATE_ACTIVE_USERS_REQUEST";
export const UPDATE_ACTIVE_USERS_RESPONSE =
  "SETTINGS/UPDATE_ACTIVE_USERS_RESPONSE";
export const UPDATE_ACTIVE_USERS_FAILURE =
  "SETTINGS/UPDATE_ACTIVE_USERS_FAILURE";

export const REGISTER_ACTIVE_USERS_REQUEST =
  "SETTINGS/REGISTER_ACTIVE_USERS_REQUEST";
export const REGISTER_ACTIVE_USERS_RESPONSE =
  "SETTINGS/REGISTER_ACTIVE_USERS_RESPONSE";
export const REGISTER_ACTIVE_USERS_FAILURE =
  "SETTINGS/REGISTER_ACTIVE_USERS_FAILURE";

export const PASSWORD_RESET_REQUEST = "SETTINGS/PASSWORD_RESET_REQUEST";
export const PASSWORD_RESET_RESPONSE = "SETTINGS/PASSWORD_RESET_RESPONSE";
export const PASSWORD_RESET_FAILURE = "SETTINGS/PASSWORD_RESET_FAILURE";

export function getMessageSettings(isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: GET_MESSAGE_SETTING_REQUEST,
      isLoading: isLoading,
    });
    return axios
      .get(`/message`)
      .then((response) => {
        let error = "";
        if (response.data.errors && response.data.errors.length > 0) {
          error = response.data.errors[0].message;
        }

        // Update/Check if user object is the obj state
        const currentUser = JSON.parse(window.localStorage.getItem("user"));
        if (currentUser) {
          dispatch({
            type: GET_MESSAGE_SETTING_RESPONSE,
            isLoading: false,
            response: response.data,
            error: error,
          });
        } else {
          // if no user is found then clear object because its an unauthorized access
          dispatch({
            type: GET_MESSAGE_SETTING_RESPONSE,
            isLoading: false,
            error: "ERROR! NO USER LOGGED IN!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: GET_MESSAGE_SETTING_FAILURE,
          isLoading: false,
          error: error,
        });
      });
  };
}

export function getSettings(isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: GET_SETTING_REQUEST,
      isLoading: isLoading,
    });
    return axios
      .get(`/setting`)
      .then((response) => {
        let error = "";
        if (response.data.errors && response.data.errors.length > 0) {
          error = response.data.errors[0].message;
        }

        // Update/Check if user object is the obj state
        const currentUser = JSON.parse(window.localStorage.getItem("user"));
        if (currentUser) {
          dispatch({
            type: GET_SETTING_RESPONSE,
            isLoading: false,
            response: response.data,
            error: error,
          });
        } else {
          // if no user is found then clear object because its an unauthorized access
          dispatch({
            type: GET_SETTING_RESPONSE,
            isLoading: false,
            error: "ERROR! NO USER LOGGED IN!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: GET_SETTING_FAILURE,
          isLoading: false,
          error: error,
        });
      });
  };
}

export function getActiveUsers(isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: GET_ACTIVE_USERS_REQUEST,
      isLoading: isLoading,
    });
    return axios
      .get(`/active-internal-users`)
      .then((response) => {
        let error = "";
        if (response.data.errors && response.data.errors.length > 0) {
          error = response.data.errors[0].message;
        }

        // Update/Check if user object is the obj state
        const currentUser = JSON.parse(window.localStorage.getItem("user"));
        if (currentUser) {
          dispatch({
            type: GET_ACTIVE_USERS_RESPONSE,
            isLoading: false,
            response: response.data,
            error: error,
          });
        } else {
          // if no user is found then clear object because its an unauthorized access
          dispatch({
            type: GET_ACTIVE_USERS_RESPONSE,
            isLoading: false,
            error: "ERROR! NO USER LOGGED IN!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: GET_MESSAGE_SETTING_FAILURE,
          isLoading: false,
          error: error,
        });
      });
  };
}

export function updateActiveUser(uuid, body, isLoading = true) {
  body.uuid = uuid;
  return (dispatch) => {
    dispatch({
      type: UPDATE_ACTIVE_USERS_REQUEST,
      isLoading: isLoading,
    });
    return axios
      .put(`/update-internal-user`, body)
      .then((response) => {
        let error = "";

        if (response.data.errors && response.data.errors.length > 0) {
          error = response.data.errors[0].message;
        }

        // Update/Check if user object is the obj state
        const currentUser = JSON.parse(window.localStorage.getItem("user"));
        if (currentUser) {
          dispatch({
            type: UPDATE_ACTIVE_USERS_RESPONSE,
            isLoading: false,
            response: response.data,
            error: error,
          });
          dispatch(setSnackbar(true, "success", "Successfully updated user."));

        } else {
          // if no user is found then clear object because its an unauthorized access
          dispatch({
            type: UPDATE_ACTIVE_USERS_RESPONSE,
            isLoading: false,
            error: "ERROR! NO USER LOGGED IN!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: UPDATE_MESSAGE_SETTING_FAILURE,
          isLoading: false,
          error: error,
        });
        dispatch(setSnackbar(true, "error", "Failed to update user."));

      });
  };
}

export function getReports() {
  return (dispatch) => {
    dispatch(GET("report", "", GET_REPORTS_REQUEST, GET_REPORTS_RESPONSE));
  };
}

// Saves several settings at once. Each PUT updates its row in the store, with one snackbar at the end.
// changes: [{ uuid, value, label }]. Resolves to the labels that failed.
export function saveSettings(changes) {
  return async (dispatch) => {
    const failed = [];
    for (const change of changes) {
      try {
        const response = await axios.put(`/setting/${change.uuid}`, { value: change.value });
        dispatch({ type: UPDATE_SETTING_RESPONSE, isLoading: false, response: response.data, error: "" });
      } catch (error) {
        failed.push(change.label);
        dispatch({ type: UPDATE_SETTING_FAILURE, isLoading: false, error: error });
      }
    }
    if (failed.length > 0) {
      dispatch(setSnackbar(true, "error", `Couldn't save ${failed.join(", ")}. Try again.`));
    } else {
      dispatch(setSnackbar(true, "success", changes.length === 1 ? "Setting saved" : `${changes.length} settings saved`));
    }
    return failed;
  };
}

// Saves a staff member's sign-in status and roles. The API resets any role left out of the body,
// so all four roles are always sent. Throws on failure so the caller can keep the form open.
export function saveInternalUser(uuid, changes) {
  return async (dispatch) => {
    await axios.put(`/update-internal-user`, { uuid, ...changes });
    await dispatch(getActiveUsers(false));
  };
}

// Invites a staff member, then saves their roles. Register always creates the user with no roles,
// so the roles go in a second call with the new user's uuid. The gateway replaces the password
// with a random one and emails a reset link; the schema only requires that one is sent.
export function inviteInternalUser({ firstName, lastName, email, roles }) {
  return async (dispatch) => {
    const { data: user } = await axios.post(`/register-internal-user`, { firstName, lastName, email, password: "password" });
    let rolesSaved = true;
    try {
      await axios.put(`/update-internal-user`, { uuid: user.uuid, ...roles });
    } catch (error) {
      rolesSaved = false;
    }
    await dispatch(getActiveUsers(false));
    return { user, rolesSaved };
  };
}

// Changes the signed-in user's password. The API checks the current password first. Throws on failure.
export function changeOwnPassword({ uuid, oldPassword, password }) {
  return async () => {
    await axios.post(`/profile-password-reset`, { uuid, oldPassword, password });
  };
}

// Saves a customer site message. Throws on failure so the editor can stay open.
export function saveMessage(uuid, changes) {
  return async (dispatch) => {
    const response = await axios.put(`/message/${uuid}`, changes);
    dispatch({ type: UPDATE_MESSAGE_SETTING_RESPONSE, isLoading: false, response: response.data, error: "" });
    return response.data;
  };
}

// Adds a customer site message, then reloads the list (the API returns the row without its id or dates).
export function createMessage(body) {
  return async (dispatch) => {
    const response = await axios.post(`/message`, body);
    await dispatch(getMessageSettings(false));
    return response.data;
  };
}
